import React, { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CookiesServices from '../../services/CookiesService';
import './ImpersonationSelect.css';

const ImpersonationSelect = () => {
    const navigate = useNavigate();
    const cookies = useMemo(() => new CookiesServices(), []);
    const [selectedUser, setSelectedUser] = useState(null);

    const users = useMemo(() => {
        try {
            const raw = cookies.get('impersonationUsers');
            if (!raw) return [];

            return typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch (e) {
            console.log('Cookie parse error:', e);
            return [];
        }
    }, [cookies]);

    useEffect(() => {
        if (users.length > 0) {
            setSelectedUser(users[0]);
        }
    }, [users]);

    const handleSelect = (user) => {
        setSelectedUser(user);
    };

    const handleContinue = () => {
        if (!selectedUser) return;

        cookies.set('kpiUser', selectedUser.kpiUser, { path: '/' });
        cookies.set('selectedImpersonationUser', JSON.stringify(selectedUser), { path: '/' });
        cookies.set('name', selectedUser.name, { path: '/' });
        cookies.set('branch', selectedUser.branch, { path: '/' });
        cookies.set('ImpersonatedUser', selectedUser.kpiUser, { path: '/' });

        window.location.href = '/dashboard';
    };

    return (
        <div className="impersonationSelect-overlay">
            <div className="impersonationSelect-popup">

                <h2 className="impersonationSelect-title">Select User to Continue</h2>

                <div className="impersonationSelect-user-list">
                    {users.map((user, i) => (
                        <div
                            key={i}
                            className={`impersonationSelect-user-card ${selectedUser?.kpiUser === user.kpiUser ? 'active' : ''
                                }`}
                            onClick={() => handleSelect(user)}
                        >
                            <div className="impersonationSelect-name">{user?.name}</div>
                            <div className="impersonationSelect-meta">Agent: {user?.kpiUser}</div>
                            <div className="impersonationSelect-meta">Branch: {user?.branch}</div>
                        </div>
                    ))}
                </div>

                <div className="impersonationSelect-button-wrapper">
                    <button className="impersonationSelect-ok-btn" onClick={handleContinue}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImpersonationSelect;